export interface ThemeDescription {
    id: number;
    name: string;
    cssFilename: string;
    representativeColor: string;
    darkTheme: boolean;
}

export const defaultThemeDescriptions: ThemeDescription[] = [
    {
        id: 1,
        name: 'Saga Blue',
        cssFilename: 'saga-blue',
        representativeColor: '#2196F3',
        darkTheme: false
    }, {
        id: 2,
        name: 'Vela Blue',
        cssFilename: 'vela-blue',
        representativeColor: '#2196F3',
        darkTheme: true
    }, {
        id: 3,
        name: 'Saga Green',
        cssFilename: 'saga-green',
        representativeColor: '#4CAF50',
        darkTheme: false
    }, {
        id: 4,
        name: 'Vela Green',
        cssFilename: 'vela-green',
        representativeColor: '#4CAF50',
        darkTheme: true
    }, {
        id: 5,
        name: 'Saga Orange',
        cssFilename: 'saga-orange',
        representativeColor: '#FF9800',
        darkTheme: false
    }, {
        id: 6,
        name: 'Vela Orange',
        cssFilename: 'vela-orange',
        representativeColor: '#FF9800',
        darkTheme: true
    }, {
        id: 7,
        name: 'Saga Purple',
        cssFilename: 'saga-purple',
        representativeColor: '#9C27B0',
        darkTheme: false
    }, {
        id: 8,
        name: 'Vela Purple',
        cssFilename: 'vela-purple',
        representativeColor: '#9C27B0',
        darkTheme: true
    },
];
